import { PautaEvento } from 'api/Assessor/pautas';
import { EditIcon, TrashIcon } from 'components/Icons';
import CadastroPautaModal from 'components/Modal/CadastroPautaModal/CadastroPautaModal';
import ConfirmDeletarPautaModal, {
  IConfirmDeletarPautaModalProps,
} from 'components/Modal/__LEGACY__/ConfirmDeletarPautaModal/ConfirmDeletarPautaModal';
import { AssemblyModalitiesNumber } from 'helpers/enums/Assembleia';
import { AssembleiaPautaStatus } from 'helpers/enums/AssembleiaPautaStatus';
import { AssembleiaStatus } from 'helpers/enums/AssembleiaStatus';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import translation from 'locales/translation';
import {
  Button,
  ButtonThemes,
  ScreenSize,
} from 'plataforma-fundacao-componentes';
import { Fragment, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { IAssembleiasAssessorEvent } from 'store/modules/AssembleiasAssessorReducer';
import { IAuthUserReducer } from 'store/modules/AuthReducer';
import { closeModal, openModal } from 'store/modules/ModalActions';
import { modalsActionsOpen } from 'store/modules/ModalsActions';
import useStyle from '../style';

interface Props {
  pauta: PautaEvento;
  evento: IAssembleiasAssessorEvent;
  usuario: IAuthUserReducer;
  currentPage: number;
  onDelete: () => void;
}

export default function PautaEditionActions({
  pauta,
  evento,
  usuario,
  currentPage,
  onDelete,
}: Props) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const hideEdition = useMemo(() => {
    if (
      evento.modo === AssemblyModalitiesNumber.HIBRIDO_PRESENCIAL_DIGITAL &&
      evento.dataBloqueio !== null
    ) {
      return true;
    }
    if (evento && evento.status >= AssembleiaStatus.Pos) {
      return true;
    }
    if (pauta.status !== AssembleiaPautaStatus.Bloqueada) {
      return true;
    }
    return false;
  }, [pauta, evento]);

  const openConfirmDeletarPautaModal = useCallback(() => {
    const modalKey: string = getUniqueKey();
    dispatch(
      modalsActionsOpen(
        ConfirmDeletarPautaModal,
        {
          genericProps: {
            key: modalKey,
            idPauta: pauta.idPauta,
            idEvento: evento?.id,
            titulo: pauta.titulo,
            presencialLiberada:
              pauta.statusPresencial !== 'BLOQUEADA' ? true : false,
            onDelete,
          } as IConfirmDeletarPautaModalProps,
        },
        modalKey
      )
    );
  }, [dispatch, pauta, evento, onDelete]);

  const openEditarPautaModal = useCallback(() => {
    const itensEditarPauta: any = pauta.itens.map((item) => ({
      id: getUniqueKey(),
      descricao: item.descricao,
      flgAbstencao: item.flgAbstencao > 0,
      idItemPauta: item.idItemPauta,
      representantes: item.representantesChapa.map((x: any) => {
        return {
          idAssociado: x.idAssociado,
          name: x.associado,
          roleName: x.nomeCargo,
        };
      }),
    }));
    const modalKey: string = getUniqueKey();
    dispatch(
      openModal(CadastroPautaModal, {
        modalKey: modalKey,
        idEvento: evento?.id,
        cooperativa: evento?.cooperativa,
        status: evento?.status,
        idPauta: pauta.idPauta,
        titulo: pauta.titulo,
        descricao: pauta.descricao,
        itens: itensEditarPauta,
        tipoPauta: pauta.tipoPauta,
        codigoAgencia: pauta.codigoAgencia,
        numeroNucleo: pauta.numeroNucleo,
        flgRestrita: pauta.flgRestrita,
        flgSecreta: pauta.flgSecreta,
        mobileOn: ScreenSize.xs,
        onClose: () => dispatch(closeModal(modalKey)),
        currentPage,
        liberadaPresencial:
          pauta.statusPresencial === 'LIBERADA' ? true : false,
      })
    );
  }, [dispatch, pauta, evento, currentPage]);

  return (
    <Fragment>
      {((usuario?.perfil.id === 'pertencer_consulta' &&
        !usuario?.perfil.assessorRoute.assembleias.pautas.deletar &&
        evento?.tipo === 'REU') ||
        usuario?.perfil.assessorRoute.assembleias.pautas.deletar) &&
        !hideEdition && (
          <Button
            data-testid={'assessor-pauta-deletar'}
            className={classes.botaoDeletar}
            theme={ButtonThemes.Danger}
            leftIcon={<TrashIcon />}
            onClick={openConfirmDeletarPautaModal}
          >
            {translation.ConfirmDeletarPauta.labelButton}
          </Button>
        )}
      {((usuario?.perfil.id === 'pertencer_consulta' &&
        !usuario?.perfil.assessorRoute.assembleias.pautas.editar &&
        evento?.tipo === 'REU') ||
        usuario?.perfil.assessorRoute.assembleias.pautas.editar) &&
        !hideEdition && (
          <Button
            data-testid={'assessor-pauta-editar'}
            className={classes.botaoEditar}
            theme={ButtonThemes.Secondary}
            leftIcon={<EditIcon />}
            onClick={openEditarPautaModal}
          >
            {translation.EditarPauta.labelButton}
          </Button>
        )}
    </Fragment>
  );
}
